import { BILLING_PAYLOAD, DATE_RANGEPICKER, LOADER } from "../../resources/actionTypes";

export function onLoaderTrigger(payload) {
    return {
      type: LOADER.LOADER_TRIGGER,
      payload: payload,
    };
  }

  export function onDateRangePicker(payload) {
    return {
      type: DATE_RANGEPICKER.DATE_RANGEPICKER_VALUE,
      payload: payload,
    };
  }

  export function getBillingPayload(payload) {
    return {
      type: BILLING_PAYLOAD.BILLING_PAYLOAD_VALUE,
      payload: payload,
    };
  }


